export function setGa4UserId(userId: string | number | null | undefined): void {
  if (typeof window === 'undefined' || !window.gtag || userId == null || userId === '') return
  window.gtag('set', {
    user_id: String(userId),
    user_properties: { settlement_user_id: String(userId) },
  })
}

export function clearGa4UserId(): void {
  if (typeof window === 'undefined' || !window.gtag) return
  window.gtag('set', {
    user_id: null,
    user_properties: { settlement_user_id: null },
  })
}
